import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { fieldInputPropTypes, fieldMetaPropTypes } from 'redux-form';
import CommonWrapper from "./CommonWrapper";
import RenderErrors from "../Renderers/RenderErrors";
import { showErrors } from "../commonFunctions";
import { Loader } from "../../Loader";
var FormGroupWrapper = function FormGroupWrapper(props) {
  // TODO: error list
  // TODO: labels with placeholders

  var input = props.input,
    children = props.children,
    label = props.label,
    classConfig = props.classConfig,
    _props$meta = props.meta,
    touched = _props$meta.touched,
    error = _props$meta.error,
    wrapperClassName = props.wrapperClassName,
    helpText = props.helpText,
    loaded = props.loaded;
  var show = showErrors(touched, error);
  return /*#__PURE__*/React.createElement(CommonWrapper, {
    wrapperClassName: wrapperClassName,
    showErrors: show
  }, label && /*#__PURE__*/React.createElement("label", {
    className: "control-label ".concat(classConfig.label),
    htmlFor: input.name
  }, label, ":"), /*#__PURE__*/React.createElement("div", {
    className: classConfig.input
  }, /*#__PURE__*/React.createElement(Loader, {
    loaded: loaded
  }, children), /*#__PURE__*/React.createElement(RenderErrors, {
    showErrors: show,
    error: error
  })), helpText !== null && /*#__PURE__*/React.createElement("p", {
    className: "help-block ".concat(classConfig.helpText)
  }, helpText));
};
FormGroupWrapper.propTypes = {
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
  meta: PropTypes.shape(fieldMetaPropTypes).isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  classConfig: PropTypes.shape({
    label: PropTypes.string,
    input: PropTypes.string,
    helpText: PropTypes.string
  }),
  children: PropTypes.node.isRequired,
  wrapperClassName: PropTypes.string,
  helpText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  loaded: PropTypes.bool
};
FormGroupWrapper.defaultProps = {
  label: null,
  classConfig: {
    label: '',
    input: '',
    helpText: ''
  },
  wrapperClassName: 'form-group',
  helpText: null,
  loaded: true
};
export default /*#__PURE__*/memo(FormGroupWrapper);